var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStableDiffusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4254_4229)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#006EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0605 17.279L23.5613 8.33887L6.63281 21.2151C6.63281 21.2151 13.6249 29.8318 13.8423 29.8318C14.0598 29.8318 24.2839 30.1286 30.0605 30.1286V17.279Z",
    fill: "#00588E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8635 5.50148C21.9384 6.44793 23.4915 8.02424 24.6718 9.95845C25.5034 11.4438 25.7086 13.4065 25.288 15.0451C24.9401 16.2198 24.4485 17.2157 23.5273 18.0471C22.132 19.4888 20.0669 19.5248 18.1888 19.5338C17.4647 19.5497 17.0104 19.6128 16.4218 20.0455C15.9954 20.5047 15.8912 20.91 15.9105 21.5205C16.0181 22.003 16.301 22.3531 16.5809 22.7534C16.8419 23.1881 16.8319 23.435 16.7549 23.9313C16.6285 24.384 16.4163 24.7051 16.0887 25.0415C14.8732 25.662 13.5221 25.4419 12.2606 25.0628C9.31014 24.064 6.92737 22.2427 5.50986 19.4292C5.04244 18.4002 4.63348 17.296 4.54232 16.1597C4.31435 13.318 4.99737 10.4641 6.83737 8.24106C8.45662 6.37602 10.7965 4.91438 13.2906 4.64105C15.5532 4.48643 17.7865 4.50995 19.8635 5.50148Z",
    fill: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.5798,
    cy: 13.3103,
    rx: 1.92941,
    ry: 1.92941,
    fill: "#B82132"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9607,
    cy: 8.59737,
    rx: 1.92941,
    ry: 1.92941,
    fill: "#FBB453"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.073,
    cy: 8.59737,
    rx: 1.92941,
    ry: 1.92941,
    fill: "#399C8D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4196,
    cy: 13.071,
    rx: 1.92941,
    ry: 1.92941,
    fill: "#086DD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4254_4229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableDiffusion);
export default __webpack_public_path__ + "static/media/stableDiffusion.29a3e35adec47ba8055cfaa2e73baf13.svg";
export { ForwardRef as ReactComponent };